import React from "react"
import { motion } from "framer-motion"

export default function MapSection() {
  return (
    <section className="py-20 lg:py-28 bg-[#f9f6f1]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Title */}
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7 }}
          viewport={{ once: true }}
          className="text-center mb-12"
        >
          <h2 className="text-3xl md:text-4xl font-bold text-[#111111]">
            Trouvez-nous
          </h2>

          <p className="text-gray-600 mt-4">
            Visitez notre centre de spa à Hammamet, en Tunisie.

          </p>
        </motion.div>

        {/* Map */}
        <motion.div
          initial={{ opacity: 0, scale: 0.95 }}
          whileInView={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="w-full h-[450px] md:h-[550px] rounded-[30px] overflow-hidden shadow-2xl"
        >
          
          <iframe
            title="Centre Spa Land Saphir Palace Map"
            src="https://maps.google.com/maps?q=Centre%20Spa%20Land%20Saphir%20Palace%20Yasmine%20Hammamet&t=&z=15&ie=UTF8&iwloc=&output=embed"
            width="100%"
            height="100%"
            className="border-0"
            loading="lazy"
            allowFullScreen=""
            referrerPolicy="no-referrer-when-downgrade"
          />
        </motion.div>
      </div>
    </section>
  )
}